module.exports = __webpack_public_path__ + "static/browsezoom-7de5bddc5075dedd7537dc485a985ebe.png";